// extracted by mini-css-extract-plugin
module.exports = {"delivery":"Delivery-module--delivery--2jl6k","heading-container":"Delivery-module--heading-container--34Hbt"};